{
  "title": "Healing Spirit",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "2nd-level conjuration",
  "level": 2,
  "castingTime": "1 bonus action",
  "range": "60 feet",
  "components": "V, S",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "You call forth a nature spirit to soothe the wounded. The intangible spirit appears in a space that is a 5-foot cube you can see within range. The spirit looks like a transparent beast or fey (your choice).",
    "Until the spell ends, whenever you or a creature you can see moves into the spirits space for the first time on a turn or starts its turn there, you can cause the spirit to restore 1d6 hit points to that creature (no action required). The spirit can’t heal constructs or undead.",
    "As a bonus action on your turn, you can move the Spirit up to 30 feet to a space you can see. The spirit can heal a number of times equal to 1 + your spellcasting ability modifier (minimum of twice). After healing that number of times, the spirit disappears.",
    "At Higher Levels. When you cast this spell using a spell slot of 3rd level or higher, the healing increases 1d6 for each slot level above 2nd."
  ],
  "spellLists": ["druid", "ranger"]
}
